import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import ImageUploader from '../../components/ImageUploader';
import useUploadImages from '../../hooks/useUploadImages';
import useCreateNews from '../../hooks/useCreateNews';
import InstagramEmbedComponent from '../../components/InstagramEmbedComponent';

const showAlert = (type, message, method, timeout = 10000) => {
  const container = document.getElementById('contact_results_' + method);
  if (!container) return;

  container.innerHTML = `
    <br/>
    <div class="alert alert-${type}" role="alert">
      ${message}
    </div>
  `;

  setTimeout(() => {
    container.innerHTML = '';
  }, timeout);
};

const NewsEntry = () => {
  const [titleBS, setTitleBS] = useState('');
  const [titleEN, setTitleEN] = useState('');
  const [excerptBS, setExcerptBS] = useState('');
  const [excerptEN, setExcerptEN] = useState('');
  const [contentBS, setContentBS] = useState('');
  const [contentEN, setContentEN] = useState('');
  const [instagramPostId, setInstagramPostId] = useState('');
  const [adminPassword, setAdminPassword] = useState('');

  const [date, setDate] = useState('');
  const [images, setImages] = useState([]);
  const [resetKey, setResetKey] = useState(0);

  const createNewsMutation = useCreateNews();
  const uploadImagesMutation = useUploadImages();

  const handleUpload = newFiles => {
    setImages(newFiles.slice(0, 1)); // samo jedna slika
  };

  const handleRemoveImage = () => setImages([]);

  const handleSubmit = async e => {
    e.preventDefault();

    if (
      !titleBS ||
      !titleEN ||
      !excerptBS ||
      !excerptEN ||
      !contentBS ||
      !contentEN ||
      !date ||
      images.length === 0 ||
      adminPassword.length === 0
    ) {
      showAlert(
        'danger',
        'Sva polja su obavezna, uključujući sliku!',
        'create'
      );
      return;
    }

    const normalizeTitle = title =>
      title
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]/g, '');

    const folderPath = `news/${normalizeTitle(titleBS)}`;

    // 1️⃣ Upload slike
    let uploadedImage = { url: '' };
    try {
      uploadedImage = await uploadImagesMutation.mutateAsync({
        files: [images[0]],
        folder: folderPath,
      });
      showAlert('success', 'Slika uspješno unesena!', 'upload');
    } catch (uploadErr) {
      console.error(uploadErr);
      showAlert('danger', 'Greška pri uploadu slike!', 'upload');
      return;
    }

    // 2️⃣ Kreiranje vijesti
    const payload = {
      title_bs: titleBS,
      title_en: titleEN,
      excerpt_bs: excerptBS,
      excerpt_en: excerptEN,
      content_bs: contentBS,
      content_en: contentEN,
      date: new Date(date),
      img: uploadedImage.urls[0],
      instagramPostId: instagramPostId || null,
      adminPassword: adminPassword,
    };

    try {
      await createNewsMutation.mutateAsync(payload);
      showAlert('success', 'Vijest uspješno unesena!', 'create');

      setTitleBS('');
      setTitleEN('');
      setExcerptBS('');
      setExcerptEN('');
      setContentBS('');
      setContentEN('');
      setInstagramPostId('');
      setAdminPassword('');
      setDate('');
      setImages([]);
      setResetKey(prev => prev + 1);
    } catch (err) {
      console.error(err);
      showAlert('danger', 'Greška pri unosu vijesti!', 'create');
    }
  };

  return (
    <div className="news-entry col-lg-12">
      <div className="paws-house-bg1 bg-light-custom element-section">
        <div className="contact-info col-lg-12">
          <h4>Unos nove vijesti</h4>

          <div className="row">
            {/* LEFT SIDE — FORM */}
            <div className="col-md-6">
              <form className="form-group" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <label>
                      Naslov (BS) <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={titleBS}
                      onChange={e => setTitleBS(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label>
                      Naslov (EN) <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={titleEN}
                      onChange={e => setTitleEN(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label>
                      Excerpt (BS) <span className="required">*</span>
                    </label>
                    <textarea
                      value={excerptBS}
                      onChange={e => setExcerptBS(e.target.value)}
                      className="form-control"
                      rows="3"
                      style={{
                        borderRadius: 0,
                      }}
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label>
                      Excerpt (EN) <span className="required">*</span>
                    </label>
                    <textarea
                      value={excerptEN}
                      onChange={e => setExcerptEN(e.target.value)}
                      className="form-control"
                      rows="3"
                      style={{
                        borderRadius: 0,
                      }}
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label>
                      Content (BS) <span className="required">*</span>
                    </label>
                    <textarea
                      value={contentBS}
                      onChange={e => setContentBS(e.target.value)}
                      className="form-control"
                      rows="10"
                      style={{
                        borderRadius: 0,
                      }}
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label>
                      Content (EN) <span className="required">*</span>
                    </label>
                    <textarea
                      value={contentEN}
                      onChange={e => setContentEN(e.target.value)}
                      className="form-control"
                      rows="10"
                      style={{
                        borderRadius: 0,
                      }}
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label>Instagram Post ID (opcionalno)</label>
                    <input
                      type="text"
                      value={instagramPostId}
                      onChange={e => setInstagramPostId(e.target.value)}
                      className="form-control"
                      placeholder="npr. CkX1zK1H5Lq"
                    />
                  </div>

                  <div className="col-md-12">
                    <label>
                      Datum <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      value={date}
                      onChange={e => setDate(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label>
                      Slika <span className="required">*</span>
                    </label>
                    <ImageUploader
                      onUpload={handleUpload}
                      onRemove={handleRemoveImage}
                      resetKey={resetKey}
                      maxFiles={1}
                    />
                  </div>

                  {/* Hidden Username to satisfy Chrome Password Manager heuristics */}
                  <input
                    type="text"
                    name="username"
                    value="admin"
                    autoComplete="username"
                    style={{ display: 'none' }}
                    readOnly
                  />

                  <div className="col-md-12">
                    <label htmlFor="adminPassword">
                      Admin Password<span className="required">*</span>
                    </label>
                    <input
                      type="password"
                      id="adminPassword"
                      name="adminPassword"
                      className="form-control"
                      autoComplete="current-password"
                      required
                      onChange={e => setAdminPassword(e.target.value)}
                    />
                  </div>

                  <button type="submit" className="btn btn-primary mt-3">
                    Unesi
                  </button>
                </div>
              </form>

              <div id="contact_results_create"></div>
              <div id="contact_results_upload"></div>
            </div>

            {/* RIGHT SIDE — LIVE PREVIEW */}
            <div className="col-md-6">
              <div
                className="card p-3 mt-3 mt-md-0"
                style={{ background: '#fafafa' }}
              >
                <h5>Preview</h5>
                <hr />

                <p>
                  <strong>Naslov (BS):</strong> {titleBS || <em>(prazno)</em>}
                </p>

                <p>
                  <strong>Naslov (EN):</strong> {titleEN || <em>(prazno)</em>}
                </p>

                <p className="mt-3">
                  <strong>Excerpt (BS):</strong>
                </p>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                  {excerptBS || <em>(prazno)</em>}
                </div>

                <p className="mt-3">
                  <strong>Excerpt (EN):</strong>
                </p>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                  {excerptEN || <em>(prazno)</em>}
                </div>

                <p className="mt-3">
                  <strong>Content (BS):</strong>
                </p>
              <div style={{ whiteSpace: 'pre-wrap' }}>
                <ReactMarkdown>{contentBS}</ReactMarkdown>
              </div>

                <p className="mt-3">
                  <strong>Content (EN):</strong>
                </p>
              <div style={{ whiteSpace: 'pre-wrap' }}>
                <ReactMarkdown>{contentEN}</ReactMarkdown>
              </div>

                {instagramPostId && (
                  <div className="mt-4">
                    <strong>Instagram Preview:</strong>
                    <div className="mt-2">
                      <InstagramEmbedComponent postId={instagramPostId} />
                    </div>
                  </div>
                )}

                <p className="mt-3">
                  <strong>Datum:</strong>{' '}
                  {date ? (
                    new Date(date).toLocaleDateString()
                  ) : (
                    <em>(nije odabran)</em>
                  )}
                </p>

                {images.length > 0 ? (
                  <div className="mt-3">
                    <strong>Preview slike:</strong>
                    <img
                      src={URL.createObjectURL(images[0])}
                      alt="preview"
                      style={{
                        width: '100%',
                        maxWidth: '300px',
                        borderRadius: '10px',
                        marginTop: '10px',
                      }}
                    />
                  </div>
                ) : (
                  <p>
                    <em>Nema učitane slike</em>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsEntry;
